import Index from './index.vue'
import ActivityList from './components/ActivityList'
import TicketFeedbackList from './components/TicketFeedbackList'
import CommentList from './components/CommentList'
import LogList from './components/LogList'

export default [
  {
    path: 'activity',
    name: 'activity',
    component: Index,
    title: 'Activity',
    redirect: { name: 'activity-list' },
    children: [
      {
        path:'activityList',
        name: 'activity-list',
        component:ActivityList
      },{
        path:'ticketFeedbackList',
        name: 'ticketFeedback-list',
        component: TicketFeedbackList
      },{
        path:'commentList',
        name: 'comment-list',
        component: CommentList
      },{
        path:'logList',
        name: 'log-list',
        component: LogList
      }
    ],
  },
]
